<template>
  <Datepicker 
    v-model="date" 
    :min-date="thisMinDate" 
    :max-date="thisMaxDate" 
    :disabled="disabled"
    month-picker 
    prevent-min-max-navigation 
    format="MMM Y" 
    ref="datepicker"
    @update:modelValue="handleDate"
    @open="onOpen"
  >
    <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
      <input type="text" :value="value" :disabled="disabled" />
    </template>
  </Datepicker>
</template>

<script>
import { nextTick } from 'vue'
import Datepicker from '@vuepic/vue-datepicker'

export default {
  props: {
    whichDate: { type: String, require: true },
    index: { type: Number, require: true },
    startMonth: { type: Date },
    endMonth: { type: Date },
    prev: { type: [Date, String] },
    disabled: { type: Boolean },
  },
  data() {
    return {
      date: null,
    }
  },
  components: {
    Datepicker
  },
  computed: {
    thisMinDate() {
      return this.startMonth
    },
    thisMaxDate() {
      return this.endMonth
    },
  },
  methods: {
    onOpen() {
      // When opening the datepicker, if a value has not get been set,
      // then set the value to the minimum date so that the menu panel 
      // is opened to the correct year.
      if (! this.date) {
        this.$refs.datepicker.updateInternalModelValue(this.thisMinDate)

        // Click the selected month so that the "Select" button in the 
        // monthpicker is no longer disabled.
        nextTick(() => {
          document.querySelector('.dp__overlay_cell_active').click()
        })
      }
    },
    clearDate() {
      this.$refs.datepicker.clearValue()
    },
    showDatepicker() {
      this.$refs.datepicker.openMenu()
    },
    handleDate(modelData) {
      if (! modelData) {
        this.$emit('update-date', this.index, null, this.whichDate)
        return
      }

      const selectedMonth = new Date(modelData.year, modelData.month, 1)
      const lastDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0)

      if (this.whichDate === 'end') {
        this.$emit('update-date', this.index, lastDate, this.whichDate)
      } else {
        this.$emit('update-date', this.index, selectedMonth, this.whichDate)
      }
    }
  },
  mounted() {

    // Set the initial date value to the minimum date.
    // this.date = {
    //   month: new Date(this.thisMinDate).getMonth(),
    //   year: new Date(this.thisMinDate).getFullYear(),
    // }

    // Restore previous date value?
    if (this.prev) {
      if (this.whichDate === 'end') {
        const lastDate = new Date(this.prev.getFullYear(), this.prev.getMonth() + 1, 0)

        this.date = {
          month: lastDate.getMonth(),
          year: lastDate.getFullYear(),
        }
      } else {
        const firstDate = new Date(this.prev)

        this.date = {
          month: new Date(firstDate).getMonth(),
          year: new Date(firstDate).getFullYear(),
        }
      }
    }
  },
}
</script>
